import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {PointGeometryUnaryMathOperator} from "#template/nodes/geometry-graph/attribute/unary-math-operator/point-geometry-unary-math-operator"
import {PointGeometryBinaryMathOperator} from "#template/nodes/geometry-graph/attribute/binary-math-operator/point-geometry-binary-math-operator"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GeometryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"
import {GeometryMathOperatorNode} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"

export type PointGeometryMathOperatorParameters = GeometryMathOperatorParameters<PointGeometryUnaryMathOperator | PointGeometryBinaryMathOperator>

const definition: TemplateNodeDefinition<PointGeometryMathOperatorParameters> = {
    nodeClass: "PointGeometryMathOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: z.union([graphNode(PointGeometryUnaryMathOperator), graphNode(PointGeometryBinaryMathOperator)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryMathOperator
    extends GeometryMathOperatorNode<0, PointGeometryUnaryMathOperator | PointGeometryBinaryMathOperator, PointGeometryMathOperatorParameters>
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
